module.exports = __webpack_public_path__ + "img/animals_panda.f22a1fb5.png";